module.exports = __webpack_public_path__ + "img/four_ten.ccc61855.svg";